"use strict";

Shopify.theme.jsTypography = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsTypography = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
    let _self = this
	let $parent = $section.find('[data-wrapper]')
    let $text = $parent.find('div')
    let max_height = 0
    let bold = isScreenSizeLarge()?this.break:this.break_mobile
    let min = isScreenSizeLarge()?this.min:this.min_mobile
    let max = isScreenSizeLarge()?this.max:this.max_mobile
    console.log(min,max,bold)
    $text.each(function(index,item){
      let size = Math.floor(Math.random() * (max - min) + min)
      if(size > bold){
      	$(item).css('font-weight', 'bold')
      }
      $(item).css('font-size', size+'px')
      if($(item).height() >= max_height){
      	max_height = $(item).height()
      }
    })
    $parent.css('max-height',max_height*2+'px')
  },
  blockSelect: function blockSelect($section, blockId) {

  },
  unload: function unload($section) {}
};